import moment, { Moment } from 'moment';
import { DELIVERY_REQUEST_STATUS } from '../constants/deliveryTracking';
import { IDeliveryInfo, IDueTimeAddition, TTakerGoDetails } from '../types/deliveryTracking';
import { COLORS } from 'src/constants/styles';
import { formatPhone } from 'src/utils/formatter';
import { dateTimeFormatForRequest } from '~/constants/dateTime';

export const getStatusColor = (status?: DELIVERY_REQUEST_STATUS) => {
  switch (status) {
    case DELIVERY_REQUEST_STATUS.NO_STATUS:
      return COLORS.GRAY;
    case DELIVERY_REQUEST_STATUS.DELIVERED:
      return COLORS.GREEN;
    case DELIVERY_REQUEST_STATUS.CANCELED:
    case DELIVERY_REQUEST_STATUS.RETURNED:
      return COLORS.RED;
    case DELIVERY_REQUEST_STATUS.DSP_ISSUE:
    case DELIVERY_REQUEST_STATUS.NOT_SENT:
      return COLORS.GRAY;
    default:
      return COLORS.MAINBLUE;
  }
};

export const getTimerStopValue = (status?: DELIVERY_REQUEST_STATUS) => {
  switch (status) {
    case DELIVERY_REQUEST_STATUS.CANCELED:
    case DELIVERY_REQUEST_STATUS.DELIVERED:
    case DELIVERY_REQUEST_STATUS.DSP_ISSUE:
    case DELIVERY_REQUEST_STATUS.RETURNED:
      return true;
    default:
      return false;
  }
};

export const isNotFullTimeLine = (status?: DELIVERY_REQUEST_STATUS): boolean => {
  return status !== DELIVERY_REQUEST_STATUS.DELIVERED && status !== DELIVERY_REQUEST_STATUS.CANCELED && status !== DELIVERY_REQUEST_STATUS.RETURNED;
};

export const getDriverInfo = (deliveryDetails: TTakerGoDetails): string => {
  let info = '';
  if (deliveryDetails.driver_name) info += `${deliveryDetails.driver_name}, `;
  if (deliveryDetails.driver_mobile) info += formatPhone(deliveryDetails.driver_mobile);
  return info;
};

export const filterInactiveStatuses = (requestStatuses: DELIVERY_REQUEST_STATUS[]): DELIVERY_REQUEST_STATUS[] => {
  // also filter string values because Object.values() for numeric enums returns keys and values
  return requestStatuses.filter(
    (status) => !isNaN(+status) && ![DELIVERY_REQUEST_STATUS.DELIVERED, DELIVERY_REQUEST_STATUS.CANCELED].includes(status)
  );
};

export const getTimerDueTime = (date: string | undefined, additionTime: IDueTimeAddition = { amount: 45, unit: 'minutes' }): Moment => {
  return moment(date).add(additionTime.amount, additionTime.unit);
};

export const addTimeZoneToRequest = (request: IDeliveryInfo): IDeliveryInfo => {
  return {
    takergo: {
      ...request.takergo,
      created_at_utc: moment.utc(request.takergo.created_at_utc).local().format(dateTimeFormatForRequest),
      last_resend_at_utc: moment.utc(request.takergo.last_resend_at_utc).local().format(dateTimeFormatForRequest),
    },
    takergo_details: request.takergo_details.map((details) => ({
      ...details,
      created_at_utc: moment.utc(details.created_at_utc).local().format(dateTimeFormatForRequest),
    })),
  };
};
